import { adminRequest } from './adminApi'
import type { UsageServiceKind } from './creditsApi'

export interface AdminUsageFilters {
  month?: string
  start?: string
  end?: string
  service_kind?: UsageServiceKind | 'all'
  model?: string
  user_id?: string
  project_id?: string
  include_internal?: boolean
}

export interface AdminUsageTotal {
  quantity: number
  input_tokens: number
  output_tokens: number
  cached_input_tokens: number
  has_missing_token_split: boolean
  cost_usd: number
  credits: number
  margin_usd: number
  count: number
  internal_cost_usd: number
  internal_credits: number
}

export interface AdminUsageRow {
  user_id?: string
  project_id?: string
  service_kind?: UsageServiceKind | ''
  unit_type?: string
  model_alias?: string
  quantity: number
  input_tokens: number
  output_tokens: number
  cached_input_tokens: number
  has_missing_token_split: boolean
  unit_price_usd?: number
  cost_usd: number
  credits: number
  margin_usd: number
  count: number
}

export interface AdminUsageDailyRow {
  date: string
  quantity: number
  cost_usd: number
  credits: number
  margin_usd: number
  count: number
}

export interface AdminUsageResponse<T> {
  rows: T[]
  total: AdminUsageTotal
}

export type AdminUsageByService = AdminUsageResponse<AdminUsageRow>
export type AdminUsageByModel = AdminUsageResponse<AdminUsageRow>
export type AdminUsageDaily = AdminUsageResponse<AdminUsageDailyRow>
export type AdminUsageSummary = AdminUsageResponse<AdminUsageRow>

function buildQuery(filters: AdminUsageFilters = {}): string {
  const qs = new URLSearchParams()
  for (const [key, value] of Object.entries(filters)) {
    if (key === 'include_internal' && value !== true) continue
    if (value === undefined || value === null || value === '' || value === 'all') continue
    qs.set(key, String(value))
  }
  const query = qs.toString()
  return query ? `?${query}` : ''
}

export const adminUsageApi = {
  byService: (filters?: AdminUsageFilters): Promise<AdminUsageByService> =>
    adminRequest<AdminUsageByService>(`/v1/admin/usage/by-service${buildQuery(filters)}`),
  byModel: (filters?: AdminUsageFilters): Promise<AdminUsageByModel> =>
    adminRequest<AdminUsageByModel>(`/v1/admin/usage/by-model${buildQuery(filters)}`),
  daily: (filters?: AdminUsageFilters): Promise<AdminUsageDaily> =>
    adminRequest<AdminUsageDaily>(`/v1/admin/usage/daily${buildQuery(filters)}`),
  get: (filters?: AdminUsageFilters): Promise<AdminUsageSummary> =>
    adminRequest<AdminUsageSummary>(`/v1/admin/usage${buildQuery(filters)}`),
}
